module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-designs/designs-5-4eb3e90a2269c1da87c237b083c3eccf.jpg";